module.exports = __webpack_public_path__ + "static/media/bg-4.082e4c01.png";